/**
 * The table the chat proposed to import, handed to the app's page in this tab
 * (too long for an address). Storage can fail: the page then opens an empty
 * import, never an error.
 */

const keyOf = (appKey: string) => `domino.table-import.${appKey}`;

export const handOverImportText = (appKey: string, text: string): void => {
  try {
    sessionStorage.setItem(keyOf(appKey), text);
  } catch {
    // Without storage the drawer opens empty; the person pastes again.
  }
};

/** Read once: a reload does not import twice. */
export const takeImportText = (appKey: string): string => {
  try {
    const text = sessionStorage.getItem(keyOf(appKey)) ?? '';
    sessionStorage.removeItem(keyOf(appKey));
    return text;
  } catch {
    return '';
  }
};
